import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b6b636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = { class: "app-wrapper" }
const _hoisted_5 = { class: "emq-table-footer" }

import { ref, computed, onMounted } from 'vue'
import { GetCooperationList } from '@/api/operation'
// 修改这里的colProps配置
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import {Search, RefreshLeft, Refresh, Plus} from '@element-plus/icons-vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { throttleBtn } from '@/common/tools'
import SelectOperator from '@/components/SelectOperator.vue'
import {pick} from "lodash";
import usePaginationRemember from "@/hooks/usePaginationRemember";
import CooperationEdit from "@/views/Support/components/CooperationEdit.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const colProps = {
  xs: 20,
  sm: 10,
  md: 8,
  lg: 6,
  xl: 3
}
const { t } = useI18nTl('Operation')
const { CooperStates, CooperTypes } = useProtocolEnums()

// 状态管理
const showCreateDialog = ref(false)
const showEditDialog = ref(false)
const showDetailDialog = ref(false) // 新增详情抽屉控制变量
const showEditData = ref({})
const detailData = ref({}) // 新增详情数据存储变量
const tableData = ref([])
const lockTable = ref(false)
const fuzzyParams = ref({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('rescueConfig')

const createConfig = () => {
  showCreateDialog.value = true
}
const GetCooperStateLabel = (type) => {
  return CooperStates.find(item => item.value === type)?.label || "-"
}

const GetCooperTypeLabel = (type) => {
  return CooperTypes.find(item => item.value === type)?.label || "-"
}

// 过滤掉Unknown状态(值为0)
const filteredCooperState = computed(() => {
  return CooperStates.filter(item => item.value !== 0)
})

const EditCooperation = (row: any) => {
  showEditData.value = { ...row }
  showEditDialog.value = true
}

// 新增详情处理方法
const handleDetail = (row: any) => {
  detailData.value = { ...row }
  showDetailDialog.value = true
}

// 搜索逻辑
const handleSearch = async () => {
  const params = {
    ...fuzzyParams.value,
    pageReq: pageParams.value
  }
  await loadTables(params)
}
const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

// 加载表格数据
const loadTables = async (params = {}) => {
  lockTable.value = true
  try {
    // 修正参数处理方式
    const queryParams = {
      ...(typeof params === 'object' ? params : {}),
      ...fuzzyParams.value,
      pageReq: {
        ...pageParams.value,
        ...(params.pageReq || {})
      }
    }

    const { list, pageReply } = await GetCooperationList(queryParams)
    const meta = toPageMeta(queryParams.pageReq, pageReply)

    tableData.value = list || []
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...fuzzyParams.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

// 修改loadDatasRefreshLimit调用方式
const loadDatasRefreshLimit = throttleBtn(() => {
  return loadTables({
    ...fuzzyParams.value,
    pageReq: pageParams.value
  })
})
onMounted(() => {
  loadTables({...fuzzyParams.value,
    pageReq: pageParams.value})
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.userName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.userName) = $event)),
                  placeholder: _ctx.$t('Base.username')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.userPhone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.userPhone) = $event)),
                  placeholder: _ctx.$t('Base.phone')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.referrerName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.referrerName) = $event)),
                  placeholder: _ctx.$t('Base.referrerName')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.referrerPhone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.referrerPhone) = $event)),
                  placeholder: _ctx.$t('Base.referrerPhone')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.state,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fuzzyParams.value.state) = $event)),
                  placeholder: _ctx.$t('Base.state')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredCooperState), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _mergeProps(colProps, { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        icon: _unref(Refresh),
        onClick: _unref(loadDatasRefreshLimit)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
        ]),
        _: 1
      }, 8, ["icon", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref: "TableCom",
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "60",
            label: _ctx.$t('Base.operatorName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "cooperType",
            "min-width": "40",
            label: _ctx.$t('Base.cooperType')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(GetCooperTypeLabel(row.cooperType)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            "min-width": "80",
            label: _ctx.$t('Base.username')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userPhone",
            "min-width": "80",
            label: _ctx.$t('Base.phone')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "referrerName",
            "min-width": "80",
            label: _ctx.$t('Base.referrerName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "referrerPhone",
            "min-width": "80",
            label: _ctx.$t('Base.referrerPhone')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            "min-width": "100",
            label: _ctx.$t('Base.remark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "40",
            label: _ctx.$t('Base.state')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(GetCooperStateLabel(row.state)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "160",
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (handleDetail(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.detail')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (EditCooperation(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'supportCooperationOperate']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[6] || (_cache[6] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTables
        }, null, 8, ["metaData"])
      ]),
      _createVNode(CooperationEdit, {
        modelValue: showEditDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showEditDialog).value = $event)),
        data: showEditData.value,
        onSuccess: _unref(loadDatasRefreshLimit)
      }, null, 8, ["modelValue", "data", "onSuccess"]),
      _createVNode(_component_el_drawer, {
        modelValue: showDetailDialog.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDetailDialog).value = $event)),
        title: _ctx.$t('Base.detail'),
        size: "30%",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: detailData.value,
            disabled: "",
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.operatorName')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.operatorName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.username')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.userName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.phone')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.userPhone || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.referrerName')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.referrerName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.referrerPhone')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.referrerPhone || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.cooperType')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(GetCooperTypeLabel(detailData.value.cooperType)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.state')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(GetCooperStateLabel(detailData.value.state)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Base.remark')), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(detailData.value.remark || '-'), 1)
                ]),
                _: 1
              }),
              (detailData.value.cooperType && detailData.value.exInfo)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (detailData.value.cooperType === 1)
                      ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                          label: _withCtx(() => [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.investAmount')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.investAmount || '-'), 1)
                          ]),
                          _: 1
                        }))
                      : (detailData.value.cooperType === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_form_item, null, {
                              label: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.spaceAddress')), 1)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.spaceAddress || '-'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              label: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.spaceArea')), 1)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.spaceArea || '-'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              label: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.havePower')), 1)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.havePower ? _ctx.$t('Base.yes') : _ctx.$t('Base.no')), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (detailData.value.cooperType === 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_el_form_item, null, {
                                label: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.cityArea')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.cityArea || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                label: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.resourceDesc')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.resourceDesc || '-'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                label: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('Operation.haveExperience')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString(detailData.value.exInfo.haveExperience ? _ctx.$t('Base.yes') : _ctx.$t('Base.no')), 1)
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})